/**
* AddNPCCommand.js
* 
* Created on 7-nov-2013, 11:48:00
*
* @author Ivo Swartjes for Ranj
**/
export default class AddNPCCommand {
    constructor(npcModel) {
        this._npcModel = npcModel;

        this.execute = function(event) {
            this._npcModel.addNpc(event.params.data.content);
            event.params.data.contentPlayer.contentCompleted(event.params.data.content);
        };
    }
}


